import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AssetsService } from "../assets.service";
import { MessagesService } from "../../messages.service";

@Component({
    selector: 'app-stock',
    templateUrl: './stock-summarized.component.html',
    styleUrls: ['./stock-summarized.component.css']
})
export class StockSummarizedComponent implements OnInit {

    /*Filtros */
    public assetsSearchCriteria: any;

    public locations: any[];
    public status: any[];
    public materials: any[];
    public containers: any[];
    public dropdownSettings = {
        singleSelection: true,
        text: 'Seleccione',
        enableSearchFilter: true,
        enableFilterSelectAll: false,
        searchPlaceholderText: 'Buscar',
        showCheckbox: true,
        noDataLabel: 'Sin registros'
    };

    /*Procesamiento*/
    public countFilters: Number;
    public loading: Boolean;

    /*Respuesta*/
    public isFiltered: Boolean;
    public filteredDate: Date;
    public page: number = 1;
    public total: number = 0;
    public assets: any[];

    constructor(private assetsService: AssetsService, private router: Router, private messagesService: MessagesService) { }

    ngOnInit() {
        this.assetsSearchCriteria = {
            "currentLocationId": null,
            "materialCode": null,
            "containerCode": null,
            "statusCode": null
        };
        this.initLoading();
        //Ver si hay que autocompletar con filtros de la navegación
        this.isFiltered = false;
        this.filteredDate = null;
        this.assets = [];
    }

    private initLoading() {
        this.countFilters = 4;
        this.loading = true;
        this.loadLocations();
        this.loadStatus();
        this.loadMaterials();
        this.loadContainers();
    }

    loadLocations() {
        this.assetsService.getLocations('I').subscribe(
            data => { this.checkLoading(); this.locations = data.map(l => ({ id: l.id, itemName: l.description }));
            console.log(data);
             },
            error => { this.checkLoading(); this.locations = []; this.checkError(error, 'Ha ocurrido un error al cargar las ubicaciones') }
        );
    }

    loadStatus() {
        this.assetsService.getStatus().subscribe(
            data => { this.checkLoading(); this.status = data.map(l => ({ id: l.code, itemName: l.description })); },
            error => { this.checkLoading(); this.status = []; this.checkError(error, 'Ha ocurrido un error al cargar las estados') }
        );
    }

    loadMaterials() {
        this.assetsService.getMaterials().subscribe(
            data => { this.checkLoading(); this.materials = data.map(l => ({ id: l.code, itemName: l.code + ' - ' + l.description })); },
            error => { this.checkLoading(); this.materials = []; this.checkError(error, 'Ha ocurrido un error al cargar los productos') }
        );
    }

    loadContainers() {
        this.assetsService.getContainers().subscribe(
            data => { this.checkLoading(); this.containers = data.map(l => ({ id: l.code, itemName: l.code + ' - ' + l.description })); },
            error => { this.checkLoading(); this.containers = []; this.checkError(error, 'Ha ocurrido un error al cargar los envases') }
        );
    }

    private checkLoading() {
        this.countFilters = (this.countFilters.valueOf() - 1);
        if (this.countFilters == 0) {
            this.loading = false;
        }
    }

    private checkError(error: any, defaultMessage: string) {
        this.messagesService.checkError(error, defaultMessage);
    }

    public search(): void {
        let searchCriteria = {
            "currentLocationId": (this.assetsSearchCriteria.currentLocationId && this.assetsSearchCriteria.currentLocationId[0]) ? this.assetsSearchCriteria.currentLocationId[0].id : null,
            "materialCode": (this.assetsSearchCriteria.materialCode && this.assetsSearchCriteria.materialCode[0]) ? this.assetsSearchCriteria.materialCode[0].id : null,
            "containerCode": (this.assetsSearchCriteria.containerCode && this.assetsSearchCriteria.containerCode[0]) ? this.assetsSearchCriteria.containerCode[0].id : null,
            "statusCode": (this.assetsSearchCriteria.statusCode && this.assetsSearchCriteria.statusCode[0]) ? this.assetsSearchCriteria.statusCode[0].id : null
        };
        this.isFiltered = true;
        this.loading = true;
        
        this.assetsService.getSumarized(searchCriteria).subscribe(
            data => { this.loading = false; this.createDataset(data); },
            error => { this.loading = false; this.checkError(error, 'Ha ocurrido un error al buscar los activos'); }
        );
    }
    
    public createDataset(data : any[]) {
        this.assets = data;
        if (this.assets.length == 0) {
             this.messagesService.viewWarning('La búsqueda no arrojó resultados');    
        }
    }

    public getColor(code: string) {
        if (code == "E") {
            return "progress-bar progress-bar-yellow";
        }
        if (code == "U") {
            return "progress-bar progress-bar-aqua";
        }
        if (code == "F") {
            return "progress-bar progress-bar-green";
        }
        return "progress-bar progress-bar-gray";
    }
    
    public getIcon(code: string) {
        if (code == "E") {
            return "fa fa-battery-empty";
        }
        if (code == "U") {
            return "fa fa-battery-half";
        }
        if (code == "F") {
            return "fa fa-battery-full";
        }
        return "gray";
    }

    public getPercentil(quantities, actual) {
        try{
            return Math.floor((actual * 100) / (quantities.map(q => q.quantity).reduce((sum, current) => sum + current)));
        } catch(e) {
            return 0;
        }
    }
    
    public getPercentilText(quantities, actual) {
        return '' + this.getPercentil(quantities, actual) + '%';
    }
}
